module.exports = __webpack_public_path__ + "static/about2-d81382f62e837f664d1b64c0c490f0aa.jpg";